import { ZMdmFileEd, zMdmFileEd } from "src/types/ZMdmFile";

export const castToFiles = (value: unknown): ZMdmFileEd[] | undefined => {
  const single = zMdmFileEd.safeParse(value);
  if (single.success) {
    return [single.data];
  }
  const multi = zMdmFileEd.array().safeParse(value);
  if (multi.success) {
    return multi.data;
  }
  return undefined;
};
